import { render, staticRenderFns } from "./UploadIncentive.vue?vue&type=template&id=3c76550a"
import script from "./UploadIncentive.vue?vue&type=script&lang=js"
export * from "./UploadIncentive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports